// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__3VATl","content":"Modal_content__3VGQL","subtext":"Modal_subtext__2TbjW","red":"Modal_red__2yd7T"};